import { useEffect, useState } from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom'
import './home.css';

// /movie/now_playing?api_key=705236d5b5522ebbe290f28f32043592&language=pt-BR

function Home(){
  const [filmes, setFilmes] = useState([]);
  const [loading, setLoading] = useState(true);

    useEffect(()=>{

      async function loadFilmes(){
        const response = await api.get("movie/now_playing", {
          params:{
            api_key: "705236d5b5522ebbe290f28f32043592",
            language: "pt-BR",
            page: 1,
          }
        })

        setFilmes(response.data.results)
        setLoading(false)

      }

      loadFilmes();

    }, [])

    if(loading){
      return(
        <div className="loading">
          <h2>Carregando filmes...</h2>
        </div>
      )
    }

  return(
    <div className="container">
      <div className="lista-filmes">
         {filmes.map((filmes)=>{
            return(
              <article key={filmes.id}>
                <strong>{filmes.title}</strong>
                <img src={`https://image.tmdb.org/t/p/original/${filmes.poster_path}`} alt={filmes.title}/>
                <Link to={`/filmes/${filmes.id}`}>Acessar</Link>
              </article>
            )
         })}
      </div>
    </div>

  )
}

export default Home;